<button mat-button (click)='click' title="{{label}}" [disabled]="disabled"
  [ngClass]="{'se-text-editor-menu-item-disabled' : disabled}">
  <mat-icon class="no-theme">{{matIconName}}</mat-icon>
</button>
